// extracted by mini-css-extract-plugin
export default {"greeting":"delivery-status_greeting__8G-ZL","heading1":"delivery-status_heading1__Gh6F3","heading2":"delivery-status_heading2__RZ20c","ingress":"delivery-status_ingress__9CuMv"};